import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d512dc80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "loading-svg",
  viewBox: "0 0 30 30"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "50%",
    cy: "50%",
    r: "10",
    class: "loading-circle"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}